import { render } from "./Index.vue?vue&type=template&id=6fe6f02d&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=6fe6f02d&scoped=true&lang=css"

import exportComponent from "/var/www/vhosts/elyosdigital.com/_build/workspace/MySchool/myschool.elyosdigital.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fe6f02d"],['__file',"resources/js/pages/homeWorks/Index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6fe6f02d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6fe6f02d', __exports__)) {
    console.log('reload')
    api.reload('6fe6f02d', __exports__)
  }
  
  module.hot.accept("./Index.vue?vue&type=template&id=6fe6f02d&scoped=true", () => {
    console.log('re-render')
    api.rerender('6fe6f02d', render)
  })

}


export default __exports__